<template>
    <section class="section">
      <div class="container">
        <h2 class="subtitle has-text-centered mt-6">Testimonials</h2>
        <div class="columns is-centered is-multiline">
            <div class="column is-4">
              <div class="box">
                <div class="content is-medium">
                  <p>
                    Feedletter is simple to set-up and easy to implement.
                    Subscriber feedback is instant and helps guide my next
                    newsletter issue.
                  </p>
                </div>
                <article class="media">
                  <figure class="media-left">
                    <p class="image is-64x64">
                      <img class="is-rounded" src="billflitter.jpg" />
                    </p>
                  </figure>
                  <div class="media-content">
                    <p class="is-size-6">
                      <strong>Bill Flitter</strong>
                    </p>
                    <p>
                      <a href="https://FixMyGrowth.com" class="has-text-success"
                        >FixMyGrowth.com</a
                      >
                    </p>
                  </div>
                </article>
              </div>
            </div>
            <div class="column is-4">
              <div class="box">
                <div class="content is-medium">
                  <p>
                    I would recommend feedletter for all those substack authors
                    or newsletter writers out there. It works magically!
                  </p>
                </div>
                <article class="media">
                  <figure class="media-left">
                    <p class="image is-64x64">
                      <img class="is-rounded" src="vaibhav.jpg" />
                    </p>
                  </figure>
                  <div class="media-content">
                    <p class="is-size-6">
                      <strong>Vaibhav Dwivedi</strong>
                    </p>
                    <p>
                      <a
                        href="https://psych.substack.com/"
                        class="has-text-success"
                        >Psych</a
                      >
                    </p>
                  </div>
                </article>
              </div>
            </div>
            <div class="column is-4">
              <div class="box">
                <div class="content is-medium">
                  <p>
                    Feedletter helps me understand what's resonating with my
                    readers, and ensures I get a little better with each issue.
                  </p>
                </div>
                <article class="media">
                  <figure class="media-left">
                    <p class="image is-64x64">
                      <img class="is-rounded" src="stefan.jpg" />
                    </p>
                  </figure>
                  <div class="media-content">
                    <p class="is-size-6">
                      <strong>Stefan von Imhof</strong>
                    </p>
                    <p>
                      <a
                        href="http://alternativeassets.club"
                        class="has-text-success"
                        >Alternative Assets</a
                      >
                    </p>
                  </div>
                </article>
              </div>
            </div>
            <div class="column is-4">
              <div class="box">
                <div class="content is-medium">
                  <p>
                   Feedletter.co is such a great feeback tool. I have always wanted to add emoji feedback to my substack but couldn't found anything that worked. Feedletter changed everything. Simple but great!
                  </p>
                </div>
                <article class="media">
                  <figure class="media-left">
                    <p class="image is-64x64">
                      <img class="is-rounded" src="naomi.jpg" />
                    </p>
                  </figure>
                  <div class="media-content">
                    <p class="is-size-6">
                      <strong>Naomi Pham</strong>
                    </p>
                    <p>
                      <a
                        href="https://mindyourbite.substack.com/"
                        class="has-text-success"
                        >Mind Your Bite</a
                      >
                    </p>
                  </div>
                </article>
              </div>
            </div>
            <div class="column is-4">
              <div class="box">
                <div class="content is-medium">
                  <p>
                   The best thing I did for my newsletter is start using FeedLetter by 
<a href="https://twitter.com/codeboje" target="_blank">@codeboje</a>
. The feedback in my most recent newsletter was more than the combined feedback of all my previous issues using Google Forms. Thank you for this amazing yet simple tool. Paid member on the spot.
                  </p>
                </div>
                <article class="media">
                  <figure class="media-left">
                    <p class="image is-64x64">
                      <img class="is-rounded" src="aadil.jpg" />
                    </p>
                  </figure>
                  <div class="media-content">
                    <p class="is-size-6">
                      <strong>Aadil Maan</strong>
                    </p>
                    <p>
                      <a
                        href="https://buildingromes.substack.com/"
                        class="has-text-success"
                        >Building Romes</a
                      >
                    </p>
                  </div>
                </article>
              </div>
            </div>
            <div class="column is-4">
              <div class="box">
                <div class="content is-medium">
                  <p>
                   I've learned more about my audience in my first month using Feedletter, than the previous four. It's simple, well-designed and easy to use. A complete gamechanger.
                  </p>
                </div>
                <article class="media">
                  <figure class="media-left">
                    <p class="image is-64x64">
                      <img class="is-rounded" src="randy.jpg" />
                    </p>
                  </figure>
                  <div class="media-content">
                    <p class="is-size-6">
                      <strong>Randy Ginsburg</strong>
                    </p>
                    <p>
                      <a
                        href="https://crashingup.com/"
                        class="has-text-success"
                        >Crashing Up</a
                      >
                    </p>
                  </div>
                </article>
              </div>
            </div>
            <div class="column is-4">
              <div class="box">
                <div class="content is-medium">
                  <p>
                   FeedLetter is our primary way of knowing if our newsletter is resonating with readers. The FeedLetter team is quick to add new features we suggest. A must have for all newsletters!
                  </p>
                </div>
                <article class="media">
                  <figure class="media-left">
                    <p class="image is-64x64">
                      <img class="is-rounded" src="mushfiq.jpg" />
                    </p>
                  </figure>
                  <div class="media-content">
                    <p class="is-size-6">
                      <strong>Mushfiq S</strong>
                    </p>
                    <p>
                      <a
                        href="https://thewebsiteflip.com/"
                        class="has-text-success"
                        >The Website Flipping Newsletter</a
                      >
                    </p>
                  </div>
                </article>
              </div>
            </div>
          </div>
        
        <h2 class="subtitle has-text-centered mt-6">On Twitter</h2>
        <div class="columns is-centered is-multiline">

          <div class="column is-6">
            <img src="/img/walloflove/1348629610494267394.png">
          </div>
          <div class="column is-6">
            <img src="/img/walloflove/1357647528116764673.png">
          </div>
          <div class="column is-6">
            <img src="/img/walloflove/1354825605364264962.png">
          </div>
          <div class="column is-6">
            <img src="/img/walloflove/1331686238210854912.png">
          </div>
          <div class="column is-6">
            <img src="/img/walloflove/1350380534288015362.png">
          </div>

          <div class="column is-6">
            <img src="/img/walloflove/1362470464468045827.png">
          </div>
          <div class="column is-6">
            <img src="/img/walloflove/1335975644837027842.png">
          </div>

          <div class="column is-6">
            <img src="/img/walloflove/1322478423713873921.png">
          </div>
          <div class="column is-6">
            <img src="/img/walloflove/1353743687147163661.png">
          </div>
        </div>
        <h2 class="subtitle has-text-centered mt-6">Elsewhere</h2>
        <div class="columns is-centered is-multiline">

          <div class="column is-12 has-text-centered">
            <img src="/img/walloflove/g2-feedback.png">
          </div>
          <div class="column is-12 has-text-centered">
            <img src="/img/walloflove/alternativeto-feedback.png">
          </div>

        </div>
      </div>
    </section>
</template>

<script>
export default {
  name: 'WallOfLoveSection',
  props: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
